import React, { useEffect, useMemo, useRef, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { newDossierValue } from '../redux/actions/devisActions';
import { fetchAllContractFacAmendment, changeContractFacAmendmentNumber, fetchFacAmendmentByDossIndex, changeFacAmendmentNumber } from '../redux/actions/facAmendmentActions';

const NumDossFacAmendment = ({ type }) => {
  const dispatch = useDispatch();
  const {
    dossierValue,
    dossier,
    contractFacAmendments,
    facAmendmentsByDossIndex,
    contractFacAmendmentIndex,
    facAmendmentIndex,
  } = useSelector((state) => ({
    dossierValue: state.devis.dossierValue,
    dossier: state.dossier.items,
    contractFacAmendments: state.facAmendment.contractFacAmendments,
    facAmendmentsByDossIndex: state.facAmendment.facAmendmentsByDossIndex,
    contractFacAmendmentIndex: state.facAmendment.contractFacAmendmentIndex,
    facAmendmentIndex: state.facAmendment.facAmendmentIndex,
  }));

  useEffect(() => {
    const fetchContractFacAmendment = async () => {
      await dispatch(fetchAllContractFacAmendment(dossierValue));
    }

    fetchContractFacAmendment();
  }, [dossierValue]);

  useEffect(() => {
    const fetchFacAmendment = async () => {
      await dispatch(fetchFacAmendmentByDossIndex(dossierValue, contractFacAmendmentIndex));
    }

    fetchFacAmendment();
  }, [dossierValue, contractFacAmendmentIndex]);

  const prevValuesRef = useRef({
    dossierValue,
    contractFacAmendmentIndex,
    facAmendmentIndex,
    dossierLength: dossier.length,
    facAmendmentsByDossIndexLength: facAmendmentsByDossIndex.length
  });

  // Mémoriser les calculs coûteux
  const sortedFacAmendment = useMemo(
    () => [...facAmendmentsByDossIndex].sort((a, b) => a.numclient.localeCompare(b.numclient)),
    [facAmendmentsByDossIndex]
  );

  const sortedContractFacAmendment = useMemo(
    () => [...contractFacAmendments]
      .sort((a, b) => a.amendment_number - b.amendment_number),
    [contractFacAmendments, dossierValue]
  );

  const handleDossierChange = (event) => {
    const newValue = event.target.value;
    if (newValue !== dossierValue) {
      dispatch(newDossierValue(newValue));
    }
  };

  const handleChangeContractFacAmendmentIndex = (event) => {
    const newValue = +event.target.value;
    if (newValue !== contractFacAmendmentIndex) {
      dispatch(changeContractFacAmendmentNumber(newValue));
    }
  };

  const handleChangeFacAmendmentIndex = (event) => {
    const newValue = +event.target.value;
    if (newValue !== facAmendmentIndex) {
      dispatch(changeFacAmendmentNumber(newValue));
    }
  };

  const showContractFacAmendment = (i, item) => (
    <option value={item.amendment_number} key={i}>
      {item.amendment_number}
    </option>
  );

  const showFacAmendment = (i, item, indexContrat) => {
    const [split1, split2] = item.nfacture.split(' ');
    const letters = ['A', 'B', 'C', 'D', 'E', 'F'];
    const index = Number(indexContrat) - 1;
    const letter = letters[index] || 'X';
    return (
      <option value={i + 1} key={i}>
        {`${letter}R${i + 1} - ${split1} ${letter}-${split2}`}
      </option>
    );
  };

  return (
    <div className="ndossier">
      <label>N° Dossier :&nbsp;</label>
      <select id="lang" onChange={handleDossierChange} value={dossierValue}>
        {dossier.map(({ ndossier }, i) => (
          <option key={i} value={ndossier}>
            {ndossier}
          </option>
        ))}
      </select>
      <label>&nbsp;Avenant :&nbsp;</label>
      <select
        id="contractfacAmendment"
        onChange={handleChangeContractFacAmendmentIndex}
        value={contractFacAmendmentIndex}
      >
        {sortedContractFacAmendment.map((item, i) => showContractFacAmendment(i, item))}
      </select>

      {type === 'facAmendment' && (
        <>
          <label>&nbsp;Facture :&nbsp;</label>
          <select
            id="facAmendment"
            onChange={handleChangeFacAmendmentIndex}
            value={facAmendmentIndex}
          >
            {sortedFacAmendment.map((item, i) => showFacAmendment(i, item, contractFacAmendmentIndex))}
          </select>
        </>
      )}
    </div>
  );
};

export default memo(NumDossFacAmendment);
